import React from 'react';
import { ShieldCheck, BadgeCheck } from 'lucide-react';

/**
 * TÜV / ABE Vertrauens-Badge - v226 Masterplan.
 *
 * Zeigt bis zu drei Vertrauens-Siegel abhängig von Produkt-Feldern:
 *  - has_tuev_certification (bool) oder legal_notice/approval_info enthält "TÜV"
 *  - has_abe (bool) oder approval_info enthält "ABE" / "EG-BE"
 *  - has_ece (bool) oder approval_info enthält "ECE"
 *
 * Auto-Detection über String-Match wenn die Booleans nicht gesetzt sind.
 */

export function detectApprovals(product) {
  const approval = String(product?.approval_info || '').toLowerCase();
  const legal    = String(product?.legal_notice || '').toLowerCase();
  const desc     = String(product?.description || '').toLowerCase();
  const combined = approval + ' ' + legal + ' ' + desc;

  return {
    tuev: !!product?.has_tuev_certification || /\btüv\b|\btuev\b/.test(combined),
    abe:  !!product?.has_abe || /\babe\b|\beg[- ]?be\b|\bteilegutachten\b/.test(combined),
    ece:  !!product?.has_ece || /\bece\b|\be1\b|\be9\b|\bemark\b/.test(combined),
  };
}

export default function TuevBadge({ product, size = 'md', className = '', style = {} }) {
  const flags = detectApprovals(product);
  if (!flags.tuev && !flags.abe && !flags.ece) return null;

  const pillSize = size === 'sm'
    ? { padding: '3px 8px', fontSize: 10, iconSize: 12 }
    : { padding: '5px 10px', fontSize: 12, iconSize: 14 };

  const pill = (label, active, color, testid, Icon = ShieldCheck) => active ? (
    <span data-testid={testid} style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      background: `${color}22`, border: `1px solid ${color}88`, color: color,
      padding: pillSize.padding, borderRadius: 6, fontSize: pillSize.fontSize,
      fontWeight: 700, letterSpacing: 0.3,
    }}>
      <Icon size={pillSize.iconSize} /> {label}
    </span>
  ) : null;

  return (
    <div className={`tuev-badges ${className}`} data-testid="tuev-badge-group" style={{
      display: 'inline-flex', gap: 6, flexWrap: 'wrap', ...style,
    }}>
      {pill('TÜV geprüft', flags.tuev, '#22c55e', 'badge-tuev', ShieldCheck)}
      {pill('ABE / Teilegutachten', flags.abe, '#3b82f6', 'badge-abe', BadgeCheck)}
      {pill('ECE-Zulassung', flags.ece, '#a78bfa', 'badge-ece', BadgeCheck)}
    </div>
  );
}
